function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function (t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}

/**
 * Given a path array return a path string
 * @param path - the path array comprising of string and number parts
 */
function formatPath(path) {
  return path.map(function (part) {
    return typeof part === 'string' ? ".".concat(part) : "[".concat(part, "]");
  }).reduce(function (l, r) {
    return l + r;
  }, '$');
}

/**
 * Determine the printed string for a value
 * @param value - a value to print
 */
function displayValue(value) {
  if (value === null) {
    return 'null';
  }
  if (value === undefined) {
    return 'undefined';
  }
  switch (_typeof(value)) {
    case 'string':
    case 'number':
    case 'boolean':
    case 'bigint':
      return JSON.stringify(value);
    case 'symbol':
      return "@@".concat(value.toString());
    case 'object':
      if (Array.isArray(value)) {
        return "[".concat(value.map(function (v) {
          return displayValue(v);
        }).join(', '), "]");
      }
      return "{".concat(Object.keys(value).map(function (key) {
        return "".concat(key, ": ").concat(displayValue(value[key]));
      }).join(', '), "}");
    default:
      return _typeof(value);
  }
}

/**
 * Converter Errors are the standard errors
 * coming from type-converters
 */
var ConverterError = /*#__PURE__*/function (_Error) {
  function ConverterError(actual, expected, path) {
    var _this;
    _classCallCheck(this, ConverterError);
    _this = _callSuper(this, ConverterError, ["At Path ".concat(formatPath(path), ", expected ").concat(expected, " but was ").concat(displayValue(actual))]);
    /**
     * The issues that occured during the conversion
     */
    _defineProperty(_this, "issues", void 0);
    _this.name = 'ConverterError';
    _this.issues = [{
      path: path,
      actual: actual,
      expected: expected
    }];
    return _this;
  }
  _inherits(ConverterError, _Error);
  return _createClass(ConverterError, [{
    key: "errorFields",
    get:
    /**
     * Error Fields records the path to fields that have an error.
     * The key of the errorFields is a path in the form of $.part[index]
     */
    function get() {
      return Object.fromEntries(this.issues.map(function (_ref) {
        var path = _ref.path,
          actual = _ref.actual,
          expected = _ref.expected;
        return [formatPath(path), {
          expected: expected,
          actual: displayValue(actual)
        }];
      }));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Error));

// find the count of errors at the max depth.
function maxDepthCount(error) {
  return error.issues.map(function (_ref) {
    var path = _ref.path;
    return path.length;
  }).reduce(function (max, d) {
    if (d === max.depth) {
      max.count += 1;
    } else if (d > max.depth) {
      max.depth = d;
      max.count = 1;
    }
    return max;
  }, {
    depth: 0,
    count: 0
  });
}

/**
 * Convert a converter function into a StandardSchema validator function
 * @param converter - the converter function to convert
 * @returns a validator function
 */
function asValidator(converter) {
  return function (input) {
    try {
      return {
        // standard schema specifies an input type but then the function uses unknown
        value: converter(input, [], input)
      };
    } catch (error) {
      if (error instanceof ConverterError) {
        // convert ConverterError into the StandardSchemaV1.FailureResult
        return {
          issues: error.issues.map(function (_ref2) {
            var path = _ref2.path,
              expected = _ref2.expected,
              actual = _ref2.actual;
            return {
              message: "expected ".concat(expected, " but was ").concat(displayValue(actual)),
              path: path
            };
          })
        };
      }
      // convert other errors into the FailureResult
      return {
        issues: [{
          message: error !== null && _typeof(error) === 'object' && 'message' in error ? "".concat(error.message) : "".concat(error)
        }]
      };
    }
  };
}

/**
 * A Converter Function
 */

/**
 * A standard Converter function with extended methods
 */

/**
 * Given a converter function get the name of the converter
 * @param converter - the converter function
 */
function getConverterName(converter) {
  return converter.displayName || converter.name || 'anonymous';
}

/**
 * Given a converter function or converter extract the result type.
 */

/**
 * Given a converter function and optional name create a converter
 * @param converter - the converter function to use to convert the values
 * @param name - the name, if not specified uses the display name or name property of the converter
 */
function createConverter(converter) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getConverterName(converter);
  return Object.defineProperties(function (input) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var entity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : input;
    return converter(input, path, entity);
  }, {
    displayName: {
      value: name,
      writable: false,
      enumerable: true
    },
    pipe: {
      value: function value(nextConverter) {
        var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "".concat(name, " -> ").concat(getConverterName(nextConverter));
        return createConverter(function (input, path, entity) {
          return nextConverter(converter(input, path, entity), path, entity);
        }, displayName);
      },
      writable: false,
      enumerable: true
    },
    or: {
      value: function value(otherConverter) {
        var joinedName = "".concat(name, " | ").concat(getConverterName(otherConverter));
        return createConverter(function (input, path, entity) {
          try {
            return converter(input, path, entity);
          } catch (err) {
            try {
              return otherConverter(input, path, entity);
            } catch (other) {
              if (err instanceof ConverterError && other instanceof ConverterError) {
                // heuristic to figure out which is the more likely branch
                var errStat = maxDepthCount(err);
                var otherStat = maxDepthCount(other);
                // if one is able to find errors deeper in the tree it's more likely
                if (errStat.depth > otherStat.depth) {
                  throw err;
                } else if (otherStat.depth > errStat.depth) {
                  throw other;
                  // the one with the most deepest errors is more likely
                } else if (errStat.count > otherStat.count) {
                  throw err;
                } else if (otherStat.count > errStat.count) {
                  throw err;
                }
                // if both have the same number of errors at the same level create a joined up error:
                // example t.string.or(t.boolean) should be "expected string | boolean but was ..."
              }
              // throw a joined up error
              throw new ConverterError(input, joinedName, path);
            }
          }
        }, joinedName);
      },
      writable: false,
      enumerable: true
    },
    "default": {
      value: function value(defaultConverter) {
        var defaultedName = "".concat(name, " with default");
        return createConverter(function (input, path, entity) {
          if (input === undefined) {
            input = defaultConverter(undefined, path, entity);
          }
          return converter(input, path, entity);
        }, defaultedName);
      },
      writable: false,
      enumerable: true
    },
    '~standard': {
      value: {
        version: 1,
        vendor: 'type-shift',
        validate: asValidator(converter)
      },
      writable: false,
      enumerable: true
    }
  });
}

/**
 * Converts values to numbers
 * This expects incoming values to be numbers or string then
 * calls the Number constructor to try to convert values
 */
var NumberConverter = createConverter(function (value, path) {
  if (typeof value === 'number' || typeof value === 'string') {
    var n = Number(value);
    if (!isNaN(n)) {
      return n;
    }
  }
  throw new ConverterError(value, 'number', path);
}, 'number');

/**
 * Converts defined non-object and non-functions to strings.
 * This calls the String constructor to convert incoming values
 */
var StringConverter = createConverter(function (value, path) {
  if (value === undefined || value === null || _typeof(value) === 'object' || typeof value === 'function') {
    throw new ConverterError(value, 'string', path);
  }
  return String(value);
}, 'string');

/**
 * Converts values to booleans
 * this accepts the string literals of "true" or "false" but otherwise expects a boolean or Boolean
 */
var BooleanConverter = createConverter(function (value, path) {
  if (typeof value === 'boolean') {
    return value;
  }
  if (value instanceof Boolean) {
    return value.valueOf();
  }
  if (value === 'true') {
    return true;
  } else if (value === 'false') {
    return false;
  }
  throw new ConverterError(value, 'boolean', path);
}, 'boolean');

/**
 * Passes through an unknown value unchanged.
 * Useful when used with the record container
 */
var UnknownConverter = createConverter(function (value) {
  return value;
}, 'unknown');

/**
 * Always throws an error no mater what value is passed
 * Useful when dealing with deprecated properties that should not be provided
 */
var NeverConverter = createConverter(function (value, path) {
  throw new ConverterError(value, 'never', path);
}, 'never');

/**
 * Given a value create a converter that must match the literal value
 * @param value - the literal value to compare to, uses === identity equality
 */
function literal(value) {
  var name = displayValue(value);
  return createConverter(function (input, path) {
    if (input === value) {
      return value;
    }
    throw new ConverterError(input, name, path);
  }, name);
}

/**
 * Converter that matches the literal null,
 * You can make values optionally nullable by using
 * t.null.or(...)
 */
var NullConverter = literal(null);

/**
 * Converter that matches the literal undefined,
 * You can make values optionally undefined by using
 * t.undefined.or(...)
 */
var UndefinedConverter = literal(undefined);

/**
 * A type representing undefined or null
 */

/**
 * Converter that matches the literal undefined or null,
 * You can make values optionally none by using
 * t.none.or(...)
 */
var NoneConverter = createConverter(function (value, path) {
  if (value === null) {
    return null;
  }
  if (value === undefined) {
    return undefined;
  }
  throw new ConverterError(value, 'none', path);
}, 'none');

/**
 * A Record\<string,T\> converter
 * @param converter - the converter to use for the values in the record
 */
function record(converter) {
  var name = "Record<string,".concat(getConverterName(converter), ">");
  return createConverter(function (value, path, entity) {
    if (value === null || value === undefined || _typeof(value) !== 'object' || Array.isArray(value)) {
      throw new ConverterError(value, name, path);
    }
    var val = value;
    var errors = [];
    var result = Object.keys(val).map(function (key) {
      var v = val[key];
      var newPath = [].concat(_toConsumableArray(path), [key]);
      try {
        return _defineProperty({}, key, converter(v, newPath, entity));
      } catch (err) {
        if (err instanceof ConverterError) {
          errors.push(err);
        } else {
          errors.push(new ConverterError(v, getConverterName(converter), newPath));
        }
        return {};
      }
    }).reduce(function (acc, obj) {
      return _objectSpread2(_objectSpread2({}, acc), obj);
    }, {});
    if (errors.length > 0) {
      throw errors.reduce(function (l, r) {
        var _l$issues;
        (_l$issues = l.issues).push.apply(_l$issues, _toConsumableArray(r.issues));
        return l;
      });
    }
    return result;
  }, name);
}

/**
 * A Array\<T\> converter
 * @param converter - the converter to use for values of the array.
 */
function array(converter) {
  var name = "Array<".concat(getConverterName(converter), ">");
  return createConverter(function (value, path, entity) {
    if (!Array.isArray(value)) {
      throw new ConverterError(value, name, path);
    }
    var errors = [];
    var result = value.map(function (v, i) {
      var newPath = [].concat(_toConsumableArray(path), [i]);
      try {
        return converter(v, newPath, entity);
      } catch (err) {
        if (err instanceof ConverterError) {
          errors.push(err);
        } else {
          errors.push(new ConverterError(v, getConverterName(converter), newPath));
        }
      }
      return undefined;
    });
    if (errors.length > 0) {
      throw errors.reduce(function (l, r) {
        var _l$issues2;
        (_l$issues2 = l.issues).push.apply(_l$issues2, _toConsumableArray(r.issues));
        return l;
      });
    }
    return result;
  }, name);
}

/**
 * Given a set of converters if one succeeds at converting the input return the
 * given value.
 *
 * @param converters - Array of converters to pass in.
 * @param value - Value to return
 *
 */
var coerce = function coerce(converters, value) {
  var predicate = converters.reduce(function (c1, c2) {
    return c1.or(c2);
  });
  return predicate.pipe(function () {
    return value;
  }, "".concat(predicate.displayName, " -> ").concat(displayValue(value)));
};

/**
 * A coercer that coerces values of None type to a null literal
 */
var noneAsNull = coerce([NoneConverter], null);

/**
 * A coercer that coerces values of None type to an undefined literal
 */
var noneAsUndefined = coerce([NoneConverter], undefined);

/**
 * Combine an arbitrary number of converters and pass their resulting
 *   values into the `combiner` function.
 *
 * @param converters - Array of converters to pass in.
 * @param combiner - Function to call with the results of all the
 *   converter functions.
 */
var compose = function compose(converters, combiner) {
  return createConverter(function (value, path, entity) {
    var args = Object.values(converters).map(function (c) {
      return c(value, path, entity);
    });
    return combiner.apply(void 0, _toConsumableArray(args));
  }, getConverterName(combiner));
};

/**
 * A decorator is a function that takes a converter function and returns
 *   a new converter function. The idea is that this new converter function
 *   will wrap the original converter function and modify its behavior.
 */

/**
 * Given a converter function make an optional converter function
 * Optional functions allow undefined values to pass-through
 * @param converter - the inner converter function
 */
function optional(converter) {
  return createConverter(function (input, path, entity) {
    if (input === undefined) {
      return undefined;
    }
    return converter(input, path, entity);
  }, "optional ".concat(getConverterName(converter)));
}

/**
 * Given a converter function make an noneable converter that allows `none`
 * types to pass through
 * @param converter - the inner converter function
 */
function noneable(converter) {
  return createConverter(function (input, path, entity) {
    if (input === undefined) {
      return undefined;
    }
    if (input === null) {
      return null;
    }
    return converter(input, path, entity);
  }, "optional ".concat(getConverterName(converter)));
}

/**
 * Given a converter function make an noneable converter function that also coerces
 * `none` to `null`
 * @param converter - the inner converter function
 */
function noneableAsNull(converter) {
  return createConverter(function (input, path, entity) {
    if (input === undefined || input === null) {
      return null;
    }
    return converter(input, path, entity);
  }, "optional ".concat(getConverterName(converter)));
}

/**
 * Given a converter function make an noneable converter function that also coerces
 * `none` to `undefined`
 * @param converter - the inner converter function
 */
function noneableAsUndefined(converter) {
  return createConverter(function (input, path, entity) {
    if (input === undefined || input === null) {
      return undefined;
    }
    return converter(input, path, entity);
  }, "optional ".concat(getConverterName(converter)));
}

/**
 * When composing functions it is useful to expose a function that doesn't take additional arguments
 * @param converter - a converter to run on the input
 * @returns a function that passes its first argument only to the converter.
 */
var convert = function convert(converter) {
  return function (input) {
    return converter(input, [], input);
  };
};

/**
 * The ShapeConverter is a converter, however we expose the
 * converters that were used to create it. This allows for these
 * converters to be spread, in order to inherit them.
 */

/**
 * A strict converter where properties not explicitly specified will not be returned
 * @param converters - an object structure describing the resulting value
 */
function strict(converters) {
  var name = "{".concat(Object.keys(converters).map(function (key) {
    return "".concat(key, ": ").concat(getConverterName(converters[key]));
  }).join(', '), "}");
  return Object.defineProperties(createConverter(function (value, path, entity) {
    var v = value === null ? {} : value;
    if (v === undefined || _typeof(v) !== 'object') {
      throw new ConverterError(value, name, path);
    }
    var errors = [];
    var result = Object.keys(converters).map(function (key) {
      var val = v[key];
      var newPath = [].concat(_toConsumableArray(path), [key]);
      var converter = converters[key];
      try {
        return _defineProperty({}, key, converter(val, newPath, entity));
      } catch (err) {
        if (err instanceof ConverterError) {
          errors.push(err);
        } else {
          errors.push(new ConverterError(val, getConverterName(converter), newPath));
        }
        return {};
      }
    }).reduce(function (acc, obj) {
      return _objectSpread2(_objectSpread2({}, acc), obj);
    }, {});
    if (errors.length > 0) {
      throw errors.reduce(function (l, r) {
        var _l$issues;
        (_l$issues = l.issues).push.apply(_l$issues, _toConsumableArray(r.issues));
        return l;
      });
    }
    return result;
  }, name), {
    converters: {
      enumerable: true,
      value: Object.keys(converters).reduce(function (l, key) {
        return _objectSpread2(_objectSpread2({}, l), {}, _defineProperty({}, key, createConverter(converters[key])));
      }, {}),
      writable: false
    },
    strict: {
      enumerable: true,
      value: true,
      writable: false
    }
  });
}

/**
 * A loose shape converter that allows unknown properties to pass through
 * Generally shape should be used if the value is going to be "re-serialized" as-is
 * This is useful for things like application stacks which may want to verify a subset of
 * properties but leave most validation up to the domain stack
 * @param converters - an object structure describing the resulting value
 */
function shape(converters) {
  var converter = strict(converters);
  return Object.defineProperties(createConverter(function (value, path, entity) {
    var result = converter(value, path, entity);
    // Find all the missing keys
    var val = value;
    return Object.keys(val).filter(function (key) {
      return !(key in converters);
    }).reduce(function (l, key) {
      return _objectSpread2(_objectSpread2({}, l), {}, _defineProperty({}, key, val[key]));
    }, result);
  }, converter.displayName), {
    converters: {
      value: converter.converters,
      writable: false,
      enumerable: true
    },
    strict: {
      value: false,
      writable: false,
      enumerable: true
    }
  });
}

/**
 * Given a shape and converter, wraps all members of the shape in that
 *   converter.
 *
 * If the given shape converter was created with the t.strict creator
 *   the resulting partial will also be strict
 * @param converter - the shape converter to make partial
 */
function decorate(decorator) {
  return function (converter) {
    if (converter.strict) {
      return strict(Object.keys(converter.converters).reduce(function (l, key) {
        return _objectSpread2(_objectSpread2({}, l), {}, _defineProperty({}, key, decorator(converter.converters[key])));
      }, {}));
    } else {
      return shape(Object.keys(converter.converters).reduce(function (l, key) {
        return _objectSpread2(_objectSpread2({}, l), {}, _defineProperty({}, key, decorator(converter.converters[key])));
      }, {}));
    }
  };
}

/**
 * Given a shape converter turns all converters into optionals.
 *
 * If the given shape converter was created with the t.strict creator
 * the resulting partial will also be strict
 * @param converter - the shape converter to make partial
 */
function partial(converter) {
  return decorate(optional)(converter);
}

/**
 * Given a shape converter turns all converters into noneable.
 *
 * If the given shape converter was created with the t.strict creator
 * the resulting partial will also be strict
 * @param converter - the shape converter to wrap all fields in noneable
 */
function noneableChildren(converter) {
  return decorate(noneable)(converter);
}

/**
 * Given a shape converter turns all converters into noneableAsUndefined.
 *
 * If the given shape converter was created with the t.strict creator
 * the resulting partial will also be strict
 * @param converter - the shape converter to wrap all fields in noneableAsUndefined
 */
function noneableChildrenAsUndefined(converter) {
  return decorate(noneableAsUndefined)(converter);
}

/**
 * Given a shape converter turns all converters into noneableAsNull.
 *
 * If the given shape converter was created with the t.strict creator
 * the resulting partial will also be strict
 * @param converter - the shape converter to wrap all fields in noneableAsNull
 */
function noneableChildrenAsNull(converter) {
  return decorate(noneableAsNull)(converter);
}

var CurrentPath = Symbol('.');
var ParentPath = Symbol('..');
/**
 * Resolves `targetPath` on `entity. Able to support both relative and absolute paths.
 *
 * @param entity - Entity to traverse.
 * @param targetPath - Targeted path to resolve.
 * @param currentPath - Path of the current converter.
 */
var followPath = function followPath(entity, targetPath, currentPath) {
  if (targetPath.length > 0) {
    // Check for relative paths
    switch (targetPath[0]) {
      case CurrentPath:
        // If current, append target path to current path.
        targetPath = [].concat(_toConsumableArray(currentPath), _toConsumableArray(targetPath.slice(1)));
        break;
      case ParentPath:
        // If parent, use currentPath minus one level per '..'.
        var count = targetPath.findIndex(function (part) {
          return part !== ParentPath;
        }, 0);
        if (count === -1) {
          // every item in targetPath is a ParentPath node
          targetPath = currentPath.slice(0, currentPath.length - targetPath.length);
        } else {
          // Otherwise return currentPath and targetPath merged.
          targetPath = [].concat(_toConsumableArray(currentPath.slice(0, currentPath.length - count)), _toConsumableArray(targetPath.slice(count)));
        }
        break;
    }
  }
  return [targetPath.reduce(function (e, part) {
    return e != null ? e[part] : e;
  }, entity), targetPath];
};

/**
 * Given a Path and a converter, invoke the converter at the given path
 * from the root entity.
 *
 * This is especially useful for migrating data from old schemas
 * @param targetPath -the path to pull data from
 */

/**
 * Given a Path and a converter, invoke the converter at the given path
 * from the root entity.
 *
 * This is especially useful for migrating data from old schemas
 * @param targetPath - the path to pull data from
 * @param converter - the converter to process the data with
 */

function forPath(targetPath) {
  var converter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : UnknownConverter;
  return createConverter(function (_, entityPath, entity) {
    var _followPath = followPath(entity, targetPath, entityPath),
      _followPath2 = _slicedToArray(_followPath, 2),
      newEntity = _followPath2[0],
      newTarget = _followPath2[1];
    return converter(newEntity, newTarget, entity);
  }, getConverterName(converter));
}

/**
 * Reroot the given converter at its current point in the tree.
 * This effectively causes functions like forPath to
 * be unable to traverse above the current point in the tree. It's useful as a way
 * to re-use converters when you have nested data.
 * @param converter - the converter to process data with
 */
function sub(converter) {
  return createConverter(function (value, path) {
    try {
      // invoke the inner converter resetting path and entity
      return converter(value, [], value);
    } catch (err) {
      if (err instanceof ConverterError) {
        // re-root all the paths
        err.issues.forEach(function (issue) {
          // prepend the current path to the issue path
          issue.path = [].concat(_toConsumableArray(path), _toConsumableArray(issue.path));
        });
      }
      throw err;
    }
  }, getConverterName(converter));
}

/**
 * One of a set of constant types
 * This uses triple equality (===) to compare
 */
function oneOf(options) {
  var name = options.map(function (v) {
    return displayValue(v);
  }).join(' | ');
  return createConverter(function (value, path) {
    if (options.includes(value)) {
      return value;
    }
    throw new ConverterError(value, name, path);
  }, name);
}

/**
 * A union type for tagged unions
 * @param tag - the branch selector selects which union branch to use
 * @param options - the union branches
 */
function taggedUnion(tag, options) {
  var name = "".concat(Object.keys(options).map(function (key) {
    return getConverterName(options[key]);
  }).join(' | '));
  return createConverter(function (value, path, entity) {
    if (value === null || value === undefined || !(tag in value)) {
      throw new ConverterError(value, name, path);
    }
    var v = "".concat(value[tag]);
    if (!(v in options)) {
      throw new ConverterError(value, name, path);
    }
    return options[v](value, path, entity);
  }, name);
}

/**
 * Flattens a converter function that returns a converter function into
 *   just a converter function.
 *
 * @param converter - Converter function to flatten.
 */
var select = function select(converter) {
  return createConverter(function (input) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var entity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : input;
    var pick = converter(input, path, entity);
    return pick(input, path, entity);
  });
};

export { ConverterError, CurrentPath, ParentPath, array, BooleanConverter as boolean, coerce, compose, convert, createConverter, decorate, displayValue, forPath, formatPath, getConverterName, literal, NeverConverter as never, NoneConverter as none, noneAsNull, noneAsUndefined, noneable, noneableAsNull, noneableAsUndefined, noneableChildren, noneableChildrenAsNull, noneableChildrenAsUndefined, NullConverter as null, NumberConverter as number, oneOf, optional, partial, record, select, shape, strict, StringConverter as string, sub, taggedUnion, UndefinedConverter as undefined, UnknownConverter as unknown };
//# sourceMappingURL=index.mjs.map
